import { useAuth0 } from '../../contexts/Auth0Context'

export async function useCurrentExpert() {
  const { user } = useAuth0()
  const expertPortalUrl = process.env.REACT_APP_EXPERT_PORTAL_URL
  const paroAppUrl = process.env.REACT_APP_PARO_APP_URL
  const formstackUrl = process.env.REACT_APP_FORMSTACK_URL
  const firmFormstackUrl = process.env.REACT_APP_FIRM_URL
  const USER_METADATA_URI = `${process.env.REACT_APP_USER_METADATA_URI}/user_metadata`
  const rolesURI = `${process.env.REACT_APP_USER_METADATA_URI}/roles`
  const roles = user[rolesURI]

  if (roles.includes('expert_active')) {
    window.location.replace(`${expertPortalUrl}/dashboardsV2`)
    return
  }

  if (roles.includes('expert_rejected')) {
    window.location.replace(`${paroAppUrl}/applicant/rejected`)
    return
  }

  if (roles.includes('expert_candidate')) {
    window.location.replace(`${paroAppUrl}/freelancer/apply/registration-review`)
    return
  }

  // ORI-1434: AIGP users should NEVER hit Formstack regardless of other role state.
  // AIGP_Partner is the authoritative signal — if present, route to dashboard directly.
  // This is defense-in-depth: even if expert_active assignment failed upstream
  // (due to Auth0 409 crash or Lambda throttle — see auth0-integration-service PR #151),
  // AIGP users still land correctly.
  //
  // TODO: ORI-1434 — Remove the entire Formstack redirect flow for AIGP users.
  // This bypass is a defense-in-depth guard. The cleaner fix is to make
  // expert_active and expert_applicant roles irrelevant for AIGP users entirely,
  // eliminating the Formstack redirect path from the AIGP journey. This would
  // require removing the role-based routing for users with AIGP_Partner and
  // replacing it with a direct route to the expert portal dashboard.
  // See: ORI-1160 (original BYOB route addition) and ORI-1332 (AIGP role logic).
  if (roles.includes('AIGP_Partner')) {
    window.location.replace(`${expertPortalUrl}/dashboardsV2`)
    return
  }

  if (roles.includes('expert_applicant')) {
    const userMetadata = user[USER_METADATA_URI]
    console.log("userMetadata?.isFirmProfile is in customed hook usecurrentexpert", userMetadata?.isFirmProfile)
    if (userMetadata?.isFirmProfile) { 
      window.location.replace(firmFormstackUrl)
      return
    }
    window.location.replace(userMetadata?.formstack_url || formstackUrl)
    return
  }
}
